import React from 'react'

import { PDFDocument } from 'pdf-lib'

import {
  formatDateTime,
  getTimezoneDate,
  timezones,
} from '../../utilities/helpers'
import {
  addBrandedTicketsToDocument,
  createTicketPdfFonts,
  formatTicketHolderName,
} from '../../utilities/ticketPdfTemplate'

import Stack from 'react-bootstrap/Stack'
import Button from 'react-bootstrap/Button'

import QRCode from 'qrcode'

import './actionBtns.scss'

export default function ActionBtns({
  handleClick,
  ticketStatus,
  order,
  eventObj,
}) {
  const event = eventObj || order?.event
  const timezone = timezones(event?.venue?.timezone)

  let hideSell =
    order?.tickets?.filter((ticket) => ticket.free === true).length > 0 ||
    !order ||
    !event?.enableResale ||
    event?.organization?.setting?.allowResales !== true

  const canPrintTickets = event?.organization?.setting?.printTickets === true

  const handlePrintPDF = async (event, tickets) => {
    if (tickets.length === 0 || !event) {
      console.warn('No Tickets or events selected')
      return
    }

    const pdfDoc = await PDFDocument.create()
    const fonts = await createTicketPdfFonts(pdfDoc)
    const logoCache = {}
    const organization = event?.organization || order?.organization
    const ticketHolder = formatTicketHolderName({
      firstName: order?.firstName,
      lastName: order?.lastName,
      email: order?.email,
      name: order?.users_permissions_user
        ? `${order.users_permissions_user.firstName || ''} ${
            order.users_permissions_user.lastName || ''
          }`.trim()
        : undefined,
    })

    const eventsMap = {}
    eventsMap[event.uuid] = event
    const ticketEntries = []

    for (const ticket of tickets) {
      const qrDataUrl = await QRCode.toDataURL(ticket.checkInCode)
      if (!qrDataUrl) {
        console.warn('Could not make qrcode...')
        return
      }

      const ticketEvent = eventsMap[ticket.eventId] || event
      if (!ticketEvent) {
        console.warn('Could not find matching event...')
        return
      }

      const zonedDate = getTimezoneDate(
        ticketEvent.start,
        ticketEvent?.timezone || timezone
      )
      const qrImage = await pdfDoc.embedPng(qrDataUrl)
      ticketEntries.push({
        ticket,
        event: ticketEvent,
        organization,
        purchasedByOrganizationName: order?.purchasedByOrganizationName,
        qrImage,
        ticketHolder,
        packageName: order?.package?.name,
        dateLabel: formatDateTime(zonedDate, 'dateOnly'),
        timeLabel: formatDateTime(zonedDate, 'timeOnly'),
      })
    }

    await addBrandedTicketsToDocument(pdfDoc, ticketEntries, {
      fonts,
      logoCache,
    })

    const pdfBytes = await pdfDoc.save()
    const blob = new Blob([pdfBytes], { type: 'application/pdf' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `${event?.name}.pdf`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }

  return (
    <Stack
      direction="horizontal"
      gap={3}
      className="btn-group-flex justify-content-center action-btns justify-content-md-end mt-md-2"
    >
      {canPrintTickets && (
        <Button
          onClick={() => handlePrintPDF(event, order?.tickets)}
          className="icon-button-sm icon-button--black btn-print"
          variant="info"
          disabled={order?.tickets?.length === 0}
          size="lg"
        >
          Print all
        </Button>
      )}
      {event?.enableTransfers && (
        <Button
          onClick={() => handleClick('transfer')}
          variant="dark"
          size="lg"
          disabled={
            ticketStatus === 'transferred' && order?.tickets?.length === 0
          }
        >
          Transfer
        </Button>
      )}
      {!hideSell && (
        <Button
          disabled={ticketStatus === 'listed' && order?.tickets?.length === 0}
          onClick={() => handleClick('sell')}
          variant="dark"
          size="lg"
        >
          Sell
        </Button>
      )}
    </Stack>
  )
}
